export const BOOKING_THEME = {
  pageBg: 'var(--cwy-bg, #f3f4f6)',
  cardBg: 'var(--cwy-cardBg, #ffffff)',
  textPrimary: 'var(--cwy-textPrimary, #0f0f0f)',
  textSecondary: 'var(--cwy-textSecondary, #4f4f4f)',
  buttonBg: 'var(--cwy-border, #e6e6e6)',
  stepperActive: 'var(--cwy-primary, #D80621)',
  stepperDone: '#2e7d32',
  border: 'var(--cwy-border, #e0e0e0)',
  slotSelected: 'rgba(216, 6, 33, 0.15)',
  slotBorder: 'var(--cwy-primary, #D80621)',
  promoAccordionBg: 'var(--cwy-cardBg, #fafafa)',
} as const;
